const el_imask = document.querySelectorAll('[data-imask-mask]');

if (el_imask.length){
    for (const elImaskElement of el_imask) {
        IMask(elImaskElement, {
            // set mask format
            mask: elImaskElement.dataset.imaskMask
        });

    }
}
